<template>
    <v-layout row wrap justify-center align-center pt-2 class="home-container container">
      <v-flex xs12 sm4 md4 lg4 mt-1 v-for="(item,index) in dataitem" :key="'itemhome'+index" class="item-container" row wrap>
        <v-flex xs2 sm12 md12 lg10>
          <div class="item-icon animated bounceIn" :class="'dura-'+index"><v-icon>{{item.Icono}}</v-icon></div>
        </v-flex>
        <v-flex xs10 sm12 md12 lg10 class="cont-text animated fadeInUp" :class="'dura-'+index">
          <div class="item-tittle">{{item.Modulo}}</div>
          <v-btn color="btndest" 
          class="no-uppercase btn-rounded d-flex item-button" 
          small block dark 
          @click="changeTo(item.idModuloPrincipal, item.Modulo, item.Path)">
          Ingresar a {{item.Modulo}}
          </v-btn>
        </v-flex>
      </v-flex>
    </v-layout>
</template>
<script>
export default {
    name:"ModuloItem",
    props: {
      dataitem: {
        type: Array,
        default: () =>[]
      },
    },
    data() {
      return {
      }
    },
    methods: {
      changeTo(idModuloPrincipal, Modulo, Path) {
      // console.log(idModuloPrincipal, Modulo);
      this.$store.dispatch('saveIdModule', idModuloPrincipal);
      this.$store.dispatch('saveTitleModule', Modulo);
      this.$router.replace({
        name: 'Inicio', 
        params: {
          Modulo: `${Path}`,
          nId: `${idModuloPrincipal}`,
          sTitle: `${Modulo}`
        }
      }).catch(err => {
        sessionStorage.err = err;
        this.$store.dispatch('saveIdModule', idModuloPrincipal);
        this.$store.dispatch('saveTitleModule', Modulo);
      });
    },
    },
}
</script>
<style lang="scss">
.home-container{
  width: 100%;
  padding: 0;
  padding-bottom: 80px;
  margin: 0 auto;
  text-align: center;
  justify-content: center;
}
.item-container{
  text-align: center;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin: 0 auto;
  padding: 10px;
  .item-icon{
    background: linear-gradient(0deg, rgba(218,218,218,1) 0%, rgba(238,238,238,1) 100%);
    width: 50px;
    height: 50px;
    border: solid #FFF 1px;
    box-shadow: 0 0 10px 3px rgba($color: #000000, $alpha: .2);
    margin: 0 auto;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    i{
    font-size: 35px;
    color:var(--v-primary-base);
    }
    @media screen and(min-width: 600px) {
      width: 70px;
      height: 70px;
      i{
        font-size: 45px;
      }
    }
  }
  .cont-text{
    padding-left: 10px;
    text-align: left;
    align-content:left;
    .item-tittle{
      font-weight: 500;
      margin-bottom: 5px;
    }
    .item-button{
      width: auto;
      padding: 10px;
      border-radius: 4px;
      background-color:var(--v-primary-base);
      color: #FFF;
      line-height: 1.3em;
      font-size: 0.8em;
      text-transform: uppercase;
      text-align: center;
    }
  }
}
</style>
